module.exports = __webpack_public_path__ + "img/design.46b03b3.jpg";